import { Box, Button, Container, Grid, Tab, Tabs, Typography } from "@mui/material"
import styleCss from "../Style/style"
import { useNavigate, useParams } from "react-router-dom"
import TopAerrow from "../img/arrowiconsingle.png"
import { useEffect, useState } from "react"
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocationImg from '../img/location-icon.png'
import UsserIcon from '../img/new-user-icon.png'
import { decryptData, encryptData } from "../Utilities/crypto"
import { AuthAxios } from "../Utilities/CommonAxios"
import showToast from "../Utilities/showToast"
import DroppingPoints from "./DroppingPoint"
import BoardingPoints from "./BoardingPoint"
import AddPassanger from "./AddPassanger"
import { useFormik } from "formik"
import * as Yup from "yup";
import dayjs from "dayjs"
import { useSelector } from "react-redux"



const BoardingSeatSelection = () => {
    const userDetails = useSelector((state) => state.auth.postItem)
    const navigate = useNavigate();
    const params = useParams();
    let bookedSeat = decryptData(params?.bookedSeat)
    bookedSeat = JSON.parse(bookedSeat)
    let bookingDetails = decryptData(params?.details);
    bookingDetails = JSON.parse(bookingDetails)
    const boardingPoint = decryptData(params?.boardingPoint);
    const travelDate = params?.travelDate;

    const droppingPoint = decryptData(params?.droppingPoint);

    const trackId = decryptData(params?.trackId)
    const [value, setValue] = useState(1);
    const [boardingpoint, setBoardingpoint] = useState([]);
    const [droppingpoint, setDroppingpoint] = useState([]);


    const [selectedBoardingId, setSelectedBoardingId] = useState(boardingPoint ?? '');
    const [selectedDroppingId, setSelectedDroppingId] = useState(droppingPoint ?? '');




    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    const boardinganddropping = async () => {
        try {
            const boardingapiResponse = await AuthAxios(({
                url: '/schedule_boarding_points',
                method: 'post',
                payload: {
                    "origin_id": bookingDetails?.origin_id,
                    "schedule_id": bookingDetails?.schedule_id
                }

            }))
            if (boardingapiResponse.status) {
                setBoardingpoint(boardingapiResponse.data || [])
            }
            const droppingapiResponse = await AuthAxios(({
                url: '/schedule_boarding_points',
                method: 'post',
                payload: {
                    "origin_id": bookingDetails?.destination_id,
                    "schedule_id": bookingDetails?.schedule_id
                }
            }))
            if (droppingapiResponse.status) {
                setDroppingpoint(droppingapiResponse?.data || [])
            }
        } catch (error) {
            showToast('error', error.message)
            setBoardingpoint([])
            setDroppingpoint([])

        }
    }


    useEffect(() => {
        boardinganddropping();
    }, [])



    const AddPassangers = () => {
        const addPassanger = [];
        for (let i = 0; i < bookedSeat.length; i++) {
            addPassanger.push({ name: '', age: '', gender: '' });
        }
        return addPassanger;
    };


    const addPassangerValidation = () => {
        if (parseInt(bookedSeat.length) !== 0) {
            return Yup.array()
                .of(
                    Yup.object({
                        name: Yup.string()
                            .required("name is required"),
                        age: Yup.string()
                            .required("age is required"),
                        gender: Yup.string()
                            .required("Gender is required"),
                    })
                )

        }

    }




    const initalValue = [
        {
            boardingPoint: boardingPoint ?? "",
            droppingPoint: droppingPoint ?? ""
        }, {
            userMobile: "",
            userEmail: userDetails.email ?? "",
            userState: "",
            addPassanger: AddPassangers()
        }
    ]




    const validation = [
        Yup.object().shape({
            boardingPoint: Yup.number().required("Enter the boarding point"),
            droppingPoint: Yup.number().required("Enter the dropping point")
        }),
        Yup.object().shape({
            userMobile: Yup.string().required("Enter the mobile number"),
            userEmail: Yup.string().required("Enter the email id"),
            addPassanger: addPassangerValidation()
        })
    ]

    const bookedDetails = (userMobileNumber, userEmailId, passangerFlag, passangerValue) => {
        const details = {
            "track_id": trackId,
            "vehicle_operator_id": bookingDetails?.operator_id,
            "trip_id": bookingDetails?.tripid,
            "schedule_id": bookingDetails?.schedule_id,
            "origin_id": bookingDetails?.origin_id,
            "destination_id": bookingDetails?.destination_id,
            "travel_date": travelDate,
            "departure_time": "08:30",
            "total_tickets": bookedSeat.length,
            "booking_date": "",
            "payment_mode": "4",
            "passenger_contact_number": userMobileNumber,
            "passenger_email_id": userEmailId,

        }
        if (passangerFlag === 1) {
            let pass = [];
            const boardingPointDetails = boardingpoint.find((item) => item.boarding_point_id === selectedBoardingId);
            const droppingPointDetails = droppingpoint.find((item) => item?.boarding_point_id === selectedDroppingId);
            for (var i = 0; i < bookedSeat.length; i++) {
                let passanger =
                {
                    "passenger_name": passangerValue[i]?.name,
                    "passenger_age": passangerValue[i]?.age,
                    "passenger_gender": passangerValue[i]?.gender,
                    "seat_number": bookedSeat[i]?.seat_number,
                    "basic_fare": 550,
                    "boarding_point": boardingPointDetails?.city_name,
                    "boarding_time": (boardingPointDetails?.bording_time.split(' ')[1]).slice(0, 5),
                    "dropping_point": droppingPointDetails?.city_name,
                    "dropping_time": (droppingPointDetails?.bording_time.split(' ')[1]).slice(0, 5),

                }
                pass.push(passanger)
            }
            details['passenger_details'] = pass
        }
        return details;
    }

    const passangerFormik = useFormik(({
        enableReinitialize: true,
        initialValues: value === 1 ? initalValue[0] : initalValue[1],
        validationSchema: value === 1 ? validation[0] : validation[1],
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: async (values) => {
            if (passangerFormik.isValid) {
                if (value === 1) {
                    setValue(2)
                    setSelectedBoardingId(values?.boardingPoint);
                    setSelectedDroppingId(values?.droppingPoint)
                } else {
                    const response = bookedDetails(values?.userMobile, values?.userEmail, 1, values?.addPassanger)
                    localStorage.setItem('_d', encryptData(JSON.stringify(response)));
                    navigate('/complete-your-payment')
                }
            } else {
                if (value === 1) {
                    showToast('error', 'select the boaring and dropping point')
                }
            }
        }
    }))



    return (
        <>
            <Grid sx={styleCss.CommonTopStyle}>
                <Container>
                    <form onSubmit={passangerFormik.handleSubmit}>
                        <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid size={{ md: 2, xs: 12 }}>
                                <img
                                    src={TopAerrow}
                                    alt="Back"
                                    style={{ transform: "rotate(180deg)", cursor: "pointer" }}
                                    onClick={() => navigate(-1)}
                                />
                            </Grid>
                            <Grid size={{ md: 8, xs: 12 }}>
                                <Grid sx={styleCss.SeatBoxStyle}>
                                    {/* Tabs */}
                                    <Box
                                        sx={{
                                            borderRadius: "30px",
                                            display: "block",
                                            padding: '6px 8px',
                                            height: "52px",
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            sx={{
                                                "& .MuiTabs-flexContainer": {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                    borderRadius: "30px",
                                                    "@media (max-width:600px)": {
                                                        flexDirection: "column",
                                                        gap: "5px",
                                                        justifyContent: "unset",
                                                    },
                                                },
                                                "& .MuiTab-root": {
                                                    textTransform: "none",
                                                    borderRadius: "30px",
                                                    minWidth: "33.3%",
                                                    fontWeight: 600,
                                                    color: "#364252",
                                                    padding: "4px 8px",
                                                    minHeight: "40px",
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: "14px",
                                                    height: "40px",
                                                    "&.Mui-selected": {
                                                        bgcolor: "#fff",
                                                        color: "#364252",
                                                    },
                                                    "@media (max-width:600px)": {
                                                        minWidth: "100%",
                                                    },
                                                },
                                                "& .MuiTabs-indicator": { display: "none" },
                                            }}
                                        >
                                            <Tab
                                                disabled
                                                icon={<CheckCircleIcon sx={{ color: "green" }} />}
                                                label="Seat Selected"
                                                iconPosition="start"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: "14px",
                                                    "&.Mui-selected": {
                                                        bgcolor: "#fff",
                                                        color: "#364252",
                                                    },
                                                }}
                                            />
                                            <Tab
                                                icon={<CheckCircleIcon sx={{ color: "green" }} />}
                                                label="Boarding / Dropping Point"
                                                iconPosition="start"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: "14px",
                                                    "&.Mui-selected": {
                                                        bgcolor: "#fff",
                                                        color: "#364252",
                                                    },
                                                }}
                                            />
                                            <Tab
                                                icon={<CheckCircleIcon sx={{ color: "green" }} />}
                                                label="Passenger Info"
                                                iconPosition="start"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: "14px",
                                                    "&.Mui-selected": {
                                                        bgcolor: "#fff",
                                                        color: "#364252",
                                                    },
                                                }}
                                            />
                                        </Tabs>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ marginTop: '30px' }}>
                            <Grid size={{ md: 8, xs: 12 }}>
                                <Box sx={{
                                    padding: "25px 20px 25px",
                                    borderRadius: "12px",
                                    backgroundColor: "#fff",
                                }}>
                                    {value === 0 &&
                                        <Grid>
                                            Seat Selected Content
                                        </Grid>}
                                    {value === 1 && (
                                        <Grid container spacing={2}>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <BoardingPoints boardingpoint={boardingpoint} formik={passangerFormik} />
                                            </Grid>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <DroppingPoints droppingpoint={droppingpoint} formik={passangerFormik} />
                                            </Grid>
                                        </Grid>
                                    )}
                                    {value === 2 &&

                                        <AddPassanger bookedSeat={bookedSeat} formik={passangerFormik} />
                                    }
                                </Box>
                            </Grid>
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Box sx={{
                                    padding: "15px 20px 10px",
                                    borderRadius: "12px",
                                    backgroundColor: "#fff",
                                    position: 'sticky',
                                    top: '80px',
                                    alignSelf: 'flex-start',
                                }}>
                                    <Typography sx={styleCss.BookingStyle}>
                                        Booking Details
                                    </Typography>
                                    <Box sx={{ borderBottom: '1px solid #f5f5f5', marginTop: '10px', marginBottom: '10px' }}></Box>
                                    <Typography sx={{ fontSize: '16px', color: "#0e182b", fontFamily: '"Segoe UI", sans-serif', fontWeight: '500' }}>Selected Seats</Typography>
                                    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                        {bookedSeat && bookedSeat.map((e, i) => (
                                            <Grid sx={{ marginRight: '10px' }}>
                                                <Typography sx={styleCss.SeatSelectionstyle}>
                                                    {e?.seat_number}
                                                </Typography>
                                            </Grid>
                                        ))}
                                        {/* <Grid>
                                        <Typography sx={styleCss.SeatSelectionstyle}>
                                            L16
                                        </Typography>
                                    </Grid> */}
                                    </Grid>
                                    <Typography sx={{ color: '#364252', fontSize: '13px', fontFamily: '"Segoe UI", sans-serif', marginBottom: '15px', marginTop: '15px' }}>
                                        {/* 21:30-05-20.Thu 04 Sep */}
                                        {/* {bookedDetails?.trip_start_time ?? ""}  */}
                                        21:30, {dayjs(travelDate).format("ddd DD MMM")} {bookingDetails?.seat_layout_name}
                                    </Typography>
                                    <Grid sx={{
                                        padding: "13px 10px",
                                        borderRadius: "5px",
                                        backgroundImage: "linear-gradient(to right, #ecfdf5, #f0fdf4)",
                                        marginBottom: '10px',
                                    }}>
                                        <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between' }}>
                                            <Typography sx={styleCss.CountNumberTotal1}>{bookingDetails?.origin_name}</Typography>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    gap: 1,
                                                }}
                                            >
                                                <Box sx={{ flex: 1, height: '1px', backgroundColor: '#e4e4e4' }} />
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 0.5,
                                                        px: 1,
                                                        borderRadius: '5px',
                                                        backgroundColor: '#ecfdf5',
                                                        color: '#717182',
                                                        fontSize: '14px',
                                                        fontFamily: '"Segoe UI", sans-serif',
                                                        fontWeight: 'normal',
                                                    }}
                                                >
                                                    <img src={LocationImg} alt="location" />
                                                    7h 15m
                                                </Box>
                                                <Box sx={{ flex: 1, height: '1px', backgroundColor: '#e4e4e4' }} />
                                            </Box>
                                            <Typography sx={styleCss.CountNumberTotal1}>{bookingDetails?.destination_name}</Typography>
                                        </Grid>
                                        <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between' }}>
                                            <Typography sx={styleCss.DateStyle}>{dayjs(travelDate).format("ddd, DD MMM")}</Typography>
                                            <Typography
                                                sx={{
                                                    ...styleCss.DateStyle,
                                                    textAlign: 'right',
                                                }}
                                            >
                                                {bookingDetails?.operator_name}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ flex: 1, height: '1px', backgroundColor: '#e4e4e4', marginTop: '15px', marginBottom: '10px' }} />
                                    <Typography sx={{ fontSize: '16px', color: "#0e182b", fontFamily: '"Segoe UI", sans-serif', fontWeight: '500', marginBottom: '10px' }}>Selected Seats</Typography>
                                    {bookedSeat && bookedSeat.map((e, i) => (
                                        <Box sx={{
                                            display: 'flex', alignItems: 'center', padding: '7px 10px',
                                            borderRadius: '5px',
                                            backgroundColor: '#f3f3f3',
                                            marginBottom: '10px',
                                        }}>
                                            <Grid>
                                                <img src={UsserIcon} alt="" style={{ verticalAlign: 'middle' }} />
                                            </Grid>
                                            <Grid sx={{ ml: 1 }}>
                                                <Typography sx={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '12px',
                                                    fontWeight: 'normal',
                                                    textAlign: 'left',
                                                    color: '#364252',
                                                }}>{e?.seat_number ?? ""} {`(${e?.seat_type.charAt(0).toUpperCase() + e?.seat_type.slice(1)})`}
                                                </Typography>
                                            </Grid>
                                            <Grid sx={{ marginLeft: 'auto' }}>
                                                <Typography sx={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    color: '#030213',
                                                }}>₹{e?.basic_fare}</Typography>
                                            </Grid>
                                        </Box>
                                    ))}
                                    <Box sx={{ flex: 1, height: '1px', backgroundColor: '#e4e4e4', marginTop: '15px', marginBottom: '10px' }} />
                                    <Box sx={{
                                        display: 'flex', alignItems: 'center', padding: '7px 10px',
                                        borderRadius: '5px',
                                        backgroundImage: 'linear-gradient(to right, #fff7ed, #fefbe9)',
                                        marginBottom: '15px',
                                    }}>
                                        <Grid sx={{ ml: 1 }}>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                                textAlign: 'left',
                                                color: '#364252',
                                                fontWeight: 'bold',
                                            }}>Total</Typography>
                                        </Grid>
                                        <Grid sx={{ marginLeft: 'auto' }}>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '15px',
                                                fontWeight: 'bold',
                                                color: '#0027d9',
                                            }}>₹{bookedSeat.reduce((sum, s) => sum + Number(s.basic_fare), 0)}

                                            </Typography>
                                        </Grid>
                                    </Box>
                                    <Button type="submit" variant="contained" sx={{
                                        padding: '7px 10px',
                                        borderRadius: '7px',
                                        backgroundColor: '#ff5714',
                                        fontFamily: 'SegoeUI',
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        textAlign: 'center',
                                        color: '#fff',
                                        fontFamily: '"Segoe UI", sans-serif',
                                        textTransform: 'capitalize',
                                        width: '100%',
                                        marginTop: '5px',
                                        marginBottom: '15px',
                                        "@media (max-width:600px)": {
                                            marginTop: '15px',
                                        },
                                    }} >Proceed to Book</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
            </Grid>
        </>
    )
}

export default BoardingSeatSelection